module.exports = __webpack_public_path__ + "img/doc-banner.40a999ce.png";